import { useMemo } from "react";
import { CardThemeIdentifier } from "./card-theme-utils";

type UseCardThemeIdentifierProps = {
  themeId?: string | null;
  occasionId?: string | null;
};

// returns a stabilized CardThemeIdentifer
export function useCardThemeIdentifier({
  themeId,
  occasionId,
}: UseCardThemeIdentifierProps): CardThemeIdentifier {
  const themeIdentifier = useMemo(() => {
    return {
      themeId,
      occasionId,
    };
  }, [themeId, occasionId]);

  return themeIdentifier;
}
